import React from 'react';
import fetch from 'isomorphic-unfetch';
import cookie from 'js-cookie';

interface Props {
  id: string;
}

const AdminUserLogInAs: React.FC<Props> = ({ id }) => {
  const logInAs = async () => {
    const token = cookie.get('token');

    const res = await fetch(process.env.API_URL + '/tds/log-in-as', {
      method: 'POST',
      body: JSON.stringify({ id, accountId: process.env.SITE!, site: null }),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    window.open(await res.text(), '_blank');
  };

  return (
    <a
      onClick={(e) => {
        e.preventDefault();
        logInAs();
      }}
    >
      <i className="fas fa-user-cog" /> Log In As
    </a>
  );
};

export default AdminUserLogInAs;
